import './components/sliders';
import './components/tabs';
import './components/galery';
import './components/filters';
import './components/accordions';
import './components/to-top';
import './components/select';
import './components/counter';
import './components/anchor';
import './components/more-review';
import './components/modals';
import './components/inputmask';
import './components/replaceEl';
import './components/main-nav';
import './components/range';
